import { PhotoSwipeLightbox } from "vendor";
var ProductNativeGallery = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const form = document.forms[this.getAttribute("form")];
    form?.addEventListener(
      "product:rerender",
      this._onSectionRerender.bind(this),
      { signal: this._abortController.signal }
    ),
      form?.addEventListener(
        "variant:change",
        this._onVariantChanged.bind(this),
        { signal: this._abortController.signal }
      ),
      (this._carousels = Array.from(this.querySelectorAll("media-carousel"))),
      (this._pageDots = Array.from(this.querySelectorAll("page-dots"))),
      (this._viewInSpaceButton = this.querySelector("[data-shopify-xr]")),
      (this._customCursor = this.querySelector(".product-gallery__cursor")),
      this.addEventListener("carousel:change", this._onCarouselChanged),
      this._viewInSpaceButton &&
        this.addEventListener(
          "carousel:settle",
          this._updateViewInSpaceButton
        ),
      this.hasAttribute("allow-zoom") &&
        this.addEventListener("lightbox:open", (event) =>
          this.openZoom(event.detail.index)
        );
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get filteredIndexes() {
    return JSON.parse(this.getAttribute("filtered-indexes")).map(
      (index) => parseInt(index) - 1
    );
  }
  get photoswipe() {
    if (this._photoswipe) return this._photoswipe;
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("photoswipe"),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      arrowPrev: !1,
      arrowNext: !1,
      counter: !1,
      zoom: !1,
      closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
      <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
      <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
      <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
    </svg>`,
    });
    return (
      photoswipe.addFilter(
        "thumbEl",
        (thumbEl, data) => data.thumbnailElement
      ),
      photoswipe.on("uiRegister", () => {
        photoswipe.pswp.ui.registerElement({
          name: "bottom-bar",
          order: 5,
          appendTo: "wrapper",
          html: `
        <div class="pagination">
          <button class="pagination__item group" rel="prev">
            <span class="animated-arrow animated-arrow--reverse"></span>
          </button>
          
          <span class="pagination__current text-sm">
            <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
          </span>
          
          <button class="pagination__item group" rel="next">
            <span class="animated-arrow"></span>
          </button>
        </div>
      `,
          onInit: (el, pswp) => {
            (el.querySelector(".pagination__page-count").innerText =
              pswp.getNumItems()),
              el
                .querySelector('[rel="prev"]')
                ?.addEventListener("click", () => pswp.prev()),
              el
                .querySelector('[rel="next"]')
                ?.addEventListener("click", () => pswp.next()),
              pswp.on("change", () => {
                el.querySelector(".pagination__current-page").innerText =
                  pswp.currIndex + 1;
              });
          },
        });
      }),
      photoswipe.init(),
      (this._photoswipe = photoswipe)
    );
  }
  openZoom(index = 0) {
    const dataSource = Array.from(
      this.querySelectorAll(
        '.product-gallery__media[data-media-type="image"]:not([hidden]) > img'
      )
    ).map((image) => ({
      thumbnailElement: image,
      src: image.src,
      srcset: image.srcset,
      msrc: image.currentSrc || image.src,
      width: parseInt(image.getAttribute("width")),
      height: parseInt(image.getAttribute("height")),
      alt: image.alt,
      thumbCropped: !0,
    }));
    this.photoswipe.loadAndOpen(index, dataSource);
  }
  _updateViewInSpaceButton(event) {
    event.detail.slide.getAttribute("data-media-type") === "model"
      ? this._viewInSpaceButton.setAttribute(
          "data-shopify-model3d-id",
          event.detail.slide.getAttribute("data-media-id")
        )
      : this._viewInSpaceButton.setAttribute(
          "data-shopify-model3d-id",
          this._viewInSpaceButton.getAttribute(
            "data-shopify-model3d-default-id"
          )
        );
  }
  _onCarouselChanged(event) {
    this._customCursor &&
      this._customCursor.toggleAttribute(
        "hidden",
        event.detail.slide.getAttribute("data-media-type") !== "image"
      );
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) return;
    let newMediaPosition;
    const featuredMedia = event.detail.variant?.featured_media;
    const previousFeaturedMedia = event.detail.previousVariant?.featured_media;
    (featuredMedia &&
      (event.detail.previousVariant === null ||
        !previousFeaturedMedia ||
        previousFeaturedMedia.id !== featuredMedia.id)) &&
      (newMediaPosition = featuredMedia.position - 1),
      newMediaPosition !== void 0 &&
        this._carousels.forEach((carousel) =>
          carousel.select(newMediaPosition, { animate: !1 })
        );
  }
  _onSectionRerender(event) {
    const galleryMarkup = deepQuerySelector(
      event.detail.htmlFragment,
      `${this.tagName}[form="${this.getAttribute("form")}"]`
    );
    if (
      galleryMarkup &&
      galleryMarkup.filteredIndex !== this.filteredIndexes
    ) {
      this.setAttribute(
        "filtered-indexes",
        galleryMarkup.getAttribute("filtered-indexes")
      );
      const filteredIndexes = this.filteredIndexes;
      this._carousels.forEach((carousel) =>
        carousel.dispatchEvent(
          new CustomEvent("carousel:filter", { detail: { filteredIndexes } })
        )
      ),
        this._pageDots.forEach((pageDots) =>
          pageDots.dispatchEvent(
            new CustomEvent("control:filter", { detail: { filteredIndexes } })
          )
        );
    }
  }
}

function deepQuerySelector(root, selector) {
  let element = root.querySelector(selector);
  if (element) return element;
  for (const template2 of root.querySelectorAll("template"))
    if (((element = deepQuerySelector(template2.content, selector)), element))
      return element;
  return null;
}

window.customElements.get("product-native-gallery") || window.customElements.define("product-native-gallery", ProductNativeGallery)
